module.exports = __webpack_public_path__ + "img/_DSC0544 2 4.8bad7b66.png";